import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Container, Button } from "reactstrap";
import Invite from "assets/image/invite.png";
import "assets/styles/components/modal.scss";
import "assets/styles/components/form.scss";
import { useSelector } from "react-redux";
import { userInfoSelector } from "store/selector/user";
import ReferralModal from "./modalReferral";

export default function FreindsReferral() {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const { referralToken } = useSelector(userInfoSelector);

  return (
    <div className="bg-primary-one">
      <Container>
        <Row className="pt-3">
          <Col
            xs="12"
            sm="12"
            lg="8"
            xl="8"
            className="d-flex flex-column justify-content-evenly align-items-start my-2"
          >
            <span className="fs-5 fw-bold text-white mb-3">
              {t("Earn money from Kevin Nick Market")}
            </span>
            <span className="text-light">{t("Invite_frinds")}</span>
            <Row className="d-flex align-items-center mt-3">
              <Col xs="12" lg="8" className="d-flex justify-content-center">
                <Button
                  size="md"
                  color="warning"
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  <Link
                    to={
                      referralToken
                        ? "#"
                        : "https://coinnik.market/app/user/login"
                    }
                    className="text-white"
                  >
                    {t("Get a friend invitation code")}
                  </Link>
                </Button>
              </Col>
              <Col
                xs="12"
                lg="4"
                className=" d-flex justify-content-center py-3"
              >
                <Link to="referral" className="text-warning-light mx-1">
                  {t("Know more")}
                </Link>
              </Col>
            </Row>
          </Col>
          <Col xs="12" sm="12" lg="4" xl="42" className="mt-n5 d-flex ">
            <img src={Invite} className="w-100 mt-5 mt-md-0" />
          </Col>
        </Row>
        {referralToken && (
          <ReferralModal setModalOpen={setModalOpen} modalOpen={modalOpen} />
        )}
      </Container>
    </div>
  );
}
